import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";
import { createGroup, deleteGroup, editGroup, getGroupByGroupNumber, updateGroupStatus } from "./CreateGroup";
// import { createGroup, deleteGroup, editGroup, getGroupByGroupNumber, updateGroupStatus } from "./createGroup";

const { Authorization, Bearer } = AUTHORIZATION;
const { post, get, put, del } = request;

const initialRoute = "admin";
const initialGroupRoute = "groups";

export const getGroups = async () => {
	try {
		const endpoint = `${initialRoute}/group`;
		const response = await get(endpoint);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error) {
		if (error.response.status === 400) {
			const { message } = error.response.data;

			if (message === MESSAGE.post.sameEntry) {
				alert("Email is already Registered with another Employee!");
			}
		} else {
			throw error;
		}
	}
};

export const getAssignedGroups = async () => {
	try {
		const endpoint = `${initialRoute}/group/assigned-groups`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			[Authorization]: `${Bearer} ${token}`,
			...headers
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

// eslint-disable-next-line arrow-parens
export const getGroup = async (group_number) => {
	try {
		const endpoint = `${initialGroupRoute}/group/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

// eslint-disable-next-line arrow-parens
export const getGroupSpecificAllLocations = async (group_number) => {
	try {
		const endpoint = `${initialGroupRoute}/group-specific-all-locations/${group_number}`;
		const token = localStorage.getItem("@jwt");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

// eslint-disable-next-line prettier/prettier, arrow-parens
export const getGroupAndLocation = async (query) => {
	try {
		const endpoint = `${initialGroupRoute}/group-and-location`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

// eslint-disable-next-line arrow-parens
export const getGroupCount = async (query) => {
	try {
		const endpoint = `${initialGroupRoute}/count`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const group = {
	getGroups,
	getAssignedGroups,
	getGroup,
	getGroupAndLocation,
	getGroupSpecificAllLocations,
	getGroupCount,
	createGroup,
	getGroupByGroupNumber,
	editGroup,
	deleteGroup,
	updateGroupStatus
};
